import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import ProtectedRoute from "../../route.protected";

import Header from "./v3/Header";
import Footer from "./v3/Footer";
import Home from "./v3/Home.js";

// import Header from "./v4/Header";
// import Footer from "./v4/Footer";
// import Home from "./v4/Home.js";

import Faq from "../Faq";
import Market from "../Market";
import Deposit from "../Deposit";
import DepositFiat from "../DepositFiat";
import Withdraw from "../Withdraw";
import WithdrawFiat from "../WithdrawFiat";
import Transactionhistory from "../Transactionhistory";
import SignIn from "../SignIn";
import SignUp from "../SignUp";
import ForgotPassword from "../ForgotPassword";
import DashboardSidebar from "../DashboardSidebar";
import CMS from "../CMS";
import Phonenumberverificationchange from "../dashboard-profile/Phone-number-verification-change";
import Emailverificationchange from "../dashboard-profile/Email-verification-change";
import Changepassworddashboard from "../dashboard-profile/Change-password-dashboard";
import AddNewPost from "../Ads/Add-New-Post";
import UpdatePost from "../Ads/Update-Postads";
import OrderDetails from "../OrderDetails";
import P2P from "../P2P-trade.js";
import Orderp2ptrade from "../Order-p2p-trade.js";
import P2pusercenter from "../P2p-user-center.js";
import P2PAdvertiserDetails from "../P2P-advertiserDetails";
import AppealHistory from "../AppealHistory.js";
import Addpaymentmethod from "../P2P-Payment-Details/add-payment-method";
import Updatepaymentmethod from "../P2P-Payment-Details/update-payment-method";
import Myadspage from "../Myads.js";
import FeeStructure from "../Fee-Structure";
import CoinStatus from "../Coin-Status";
import GoogleAuthenticator from "../dashboard-profile/Google-Authenticator";
import DeviceManagement from "../dashboard-profile/DeviceManagement";
import Spot from "../exchange-trade/Spot";
import Earn from "../Finance/Earn.js";
import DownloadApp from "../DownloadApp";
import Comingsoon from "../Comingsoon";
import Error404 from "../Error404";

// import ScrollToTop from "./v3/ScrollToup.jsx";

export default function CommonLayout(props) {
  const routes = [
    {
      path: "/",
      name: "home",
      component: (
        <Home setTheme={props.setTheme} theme={props.theme} identify="home" />
      ),
    },
    {
      path: "/",
      name: "home-2",
      component: (
        <Home setTheme={props.setTheme} theme={props.theme} identify="home" />
      ),
    },
    {
      path: "/faq",
      component: (
        <Faq setTheme={props.setTheme} theme={props.theme} identify="faq" />
      ),
    },
    {
      path: "/markets",
      component: (
        <Market
          setTheme={props.setTheme}
          theme={props.theme}
          identify="markets"
        />
      ),
    },
    {
      path: "/about",
      component: (
        <CMS setTheme={props.setTheme} theme={props.theme} identify="about" />
      ),
    },
    {
      path: "/contact-support",
      component: (
        <CMS
          setTheme={props.setTheme}
          theme={props.theme}
          identify="contactus"
        />
      ),
    },
    {
      path: "/terms",
      component: (
        <CMS setTheme={props.setTheme} theme={props.theme} identify="terms" />
      ),
    },
    {
      path: "/privacy-policy",
      component: (
        <CMS setTheme={props.setTheme} theme={props.theme} identify="privacy" />
      ),
    },
    {
      path: "/fee-structure",
      component: <FeeStructure setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/coin-status",
      component: <CoinStatus setTheme={props.setTheme} theme={props.theme} />,
    },

    // user entry
    {
      path: "/register",
      authChk: "beforeLoginOnly",
      component: <SignUp setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/login",
      authChk: "beforeLoginOnly",
      component: <SignIn setTheme={props.setTheme} theme={props.theme} />,
    },
    // {
    //   path: "/register-new",
    //   authChk: "beforeLoginOnly",
    //   component: <Register setTheme={props.setTheme} theme={props.theme} />,
    // },
    // {
    //   path: "/login-new",
    //   authChk: "beforeLoginOnly",
    //   component: <Login setTheme={props.setTheme} theme={props.theme} />,
    // },
    {
      path: "/ForgotPassword",
      authChk: "beforeLoginOnly",
      component: (
        <ForgotPassword setTheme={props.setTheme} theme={props.theme} />
      ),
    },

    // user
    {
      path: "/my/wallet/history",
      authChk: "afterLoginOnly",
      component: (
        <Transactionhistory setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/my/wallet/history/:tabName",
      authChk: "afterLoginOnly",
      component: (
        <Transactionhistory setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/my/sms-authenticator",
      authChk: "afterLoginOnly",
      component: (
        <Phonenumberverificationchange
          setTheme={props.setTheme}
          theme={props.theme}
        />
      ),
    },
    {
      path: "/my/email-authenticator",
      authChk: "afterLoginOnly",
      component: (
        <Emailverificationchange
          setTheme={props.setTheme}
          theme={props.theme}
        />
      ),
    },
    {
      path: "/my/password",
      authChk: "afterLoginOnly",
      component: (
        <Changepassworddashboard
          setTheme={props.setTheme}
          theme={props.theme}
        />
      ),
    },
    {
      path: "/my/:tabName",
      authChk: "afterLoginOnly",
      loadFooter: false,
      component: (
        <DashboardSidebar setTheme={props.setTheme} theme={props.theme} />
      ),
    },

    {
      path: "/deposit/crypto",
      authChk: "afterLoginOnly",
      component: <Deposit setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/deposit/crypto/:currencyId",
      authChk: "afterLoginOnly",
      component: <Deposit setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/deposit/request/:currencySymbol",
      authChk: "afterLoginOnly",
      component: <DepositFiat setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/deposit",
      authChk: "afterLoginOnly",
      component: <Deposit setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/withdraw/request/:currencyId",
      authChk: "afterLoginOnly",
      component: <WithdrawFiat setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/withdraw/crypto/:currencyId",
      authChk: "afterLoginOnly",
      component: <Withdraw setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/withdraw",
      authChk: "afterLoginOnly",
      component: <Withdraw setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/google-authenticator",
      authChk: "afterLoginOnly",
      component: (
        <GoogleAuthenticator setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/device-management",
      component: (
        <DeviceManagement setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    // p2p
    {
      path: "/trade/all-payments",
      component: (
        <P2P setTheme={props.setTheme} theme={props.theme} identify="p2p" />
      ),
    },
    {
      path: "/p2p-orders-list",
      component: (
        <Orderp2ptrade setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/p2p-user-center",
      authChk: "afterLoginOnly",
      component: (
        <P2pusercenter setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/p2p-advertiser-user-center/:advertiserNo",
      authChk: "afterLoginOnly",
      component: (
        <P2PAdvertiserDetails setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/payment/add/:paymentId",
      authChk: "afterLoginOnly",
      component: (
        <Addpaymentmethod setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/payment/edit/:paymentId",
      authChk: "afterLoginOnly",
      component: (
        <Updatepaymentmethod setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/myads",
      authChk: "afterLoginOnly",
      component: <Myadspage setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/edit-myads/:editId",
      authChk: "afterLoginOnly",
      component: <UpdatePost setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/postAd",
      authChk: "afterLoginOnly",
      component: <AddNewPost setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/order-details/:orderId",
      authChk: "afterLoginOnly",
      component: <OrderDetails setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/appeal-history/:orderId",
      authChk: "afterLoginOnly",
      component: (
        <AppealHistory setTheme={props.setTheme} theme={props.theme} />
      ),
    },
    {
      path: "/spot/:pairName",
      component: (
        <Spot setTheme={props.setTheme} theme={props.theme} identify="spot" />
      ),
    },
    {
      path: "/staking",
      component: (
        <Earn
          setTheme={props.setTheme}
          theme={props.theme}
          identify="staking"
        />
      ),
    },
    {
      path: "/download/app",
      component: <DownloadApp setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/comingsoon",
      component: <Comingsoon setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/error404",
      component: <Error404 setTheme={props.setTheme} theme={props.theme} />,
    },
    {
      path: "/:dynCMS",
      component: (
        <CMS setTheme={props.setTheme} theme={props.theme} identify="dyn" />
      ),
    },
    {
      path: "*",
      component: <Error404 setTheme={props.setTheme} theme={props.theme} />,
    },
  ];
  return (
    <div className="app">
      <Header
        setTheme={props.setTheme}
        theme={props.theme}
        identify={props.identify}
        pageName={"Faq"}
      />
      <main className="routes-div">
        <Routes>
          {routes.map((data, index) => {
            return (
              <Route
                element={
                  <ProtectedRoute authChk={data.authChk ? data.authChk : ""} />
                }
              >
                <Route
                  onUpdate={() => window.scrollTo(0, 0)}
                  exact={true}
                  path={data.path}
                  element={data.component}
                  name={data.name}
                  key={index}
                />
              </Route>
            );
          })}
        </Routes>
        <Footer />
      </main>
    </div>
  );
}
